import axios from 'axios';

const BASE_URL = '/api/v1';

const axiosClient = axios.create({
  baseURL: BASE_URL,
  timeout: 20000,
  withCredentials: true,
});

export default function useAxios() {
  return axiosClient;
}
